import { useSelector } from 'react-redux';
import useTranslation from '../../../hooks/useTranslations';
import { selectRecentlyViewedObjects } from '../../../redux/modules/data/objectsSlice';
import ContentWrapper from '../layouts/partials/ContentWrapper';
import SidebarWrapper from '../layouts/partials/SidebarWrapper';
import PrivateLayout from '../layouts/PrivateLayout';
import ObjectTile from './partials/tiles/ObjectTile';
import TileWrapper from './partials/TileWrapper';

const RecentlyViewedScreen = () => {
	const t = useTranslation();

	const recentlyViewedObjects = useSelector((state) => selectRecentlyViewedObjects(state));

	const breadcrumb = [{ route: 'recently-viewed', translationKey: 'dashboard_recently_used_button' }];

	return (
		<PrivateLayout customTree={breadcrumb}>
			<SidebarWrapper title={t('dashboard_recently_used_button')} customTree={breadcrumb} />
			<ContentWrapper title={recentlyViewedObjects.length === 0 ? t('search_no_documents_found') : '\u00A0'}>
				{recentlyViewedObjects.length > 0 && (
					<>
						<TileWrapper containerClasses="pt-2">
							{recentlyViewedObjects && recentlyViewedObjects.slice(0, 48).reverse().map((object) => <ObjectTile key={object.id} object={object} setIsModalOpen={false} />)}
						</TileWrapper>
					</>
				)}
			</ContentWrapper>
		</PrivateLayout>
	);
};

export default RecentlyViewedScreen;
